/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminRebuildBracketResponse
 */
export interface AdminRebuildBracketResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminRebuildBracketResponse
     */
    tournamentId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminRebuildBracketResponse
     */
    bracketId: string;
    /**
     * 
     * @type {number}
     * @memberof AdminRebuildBracketResponse
     */
    teamCount: number;
}

/**
 * Check if a given object implements the AdminRebuildBracketResponse interface.
 */
export function instanceOfAdminRebuildBracketResponse(value: object): value is AdminRebuildBracketResponse {
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    if (!('bracketId' in value) || value['bracketId'] === undefined) return false;
    if (!('teamCount' in value) || value['teamCount'] === undefined) return false;
    return true;
}

export function AdminRebuildBracketResponseFromJSON(json: any): AdminRebuildBracketResponse {
    return AdminRebuildBracketResponseFromJSONTyped(json, false);
}

export function AdminRebuildBracketResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminRebuildBracketResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'tournamentId': json['tournamentId'],
        'bracketId': json['bracketId'],
        'teamCount': json['teamCount'],
    };
}

export function AdminRebuildBracketResponseToJSON(json: any): AdminRebuildBracketResponse {
    return AdminRebuildBracketResponseToJSONTyped(json, false);
}

export function AdminRebuildBracketResponseToJSONTyped(value?: AdminRebuildBracketResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tournamentId': value['tournamentId'],
        'bracketId': value['bracketId'],
        'teamCount': value['teamCount'],
    };
}

